export default __webpack_public_path__ + "static/media/deviceIcon.167fb69c.svg";